import C from "../Constants";
import EventHelperCommon from "../scheduler-event-helper/common";
import EventHelperCrew from "../scheduler-event-helper/crew";

/**
 * イベント結合処理
 * @param {Store} store
 * @param {String} resourceId
 */
const concateEventsAsync = async (store, resourceId) => {
  const targetsEvents = store.query(event => {
    return (
      EventHelperCommon.isScheduled(event) &&
      event.resourceId === resourceId &&
      !EventHelperCommon.isSoftDeleted(event)
    );
  }, true);

  // 開始日でソート
  targetsEvents.sort(EventHelperCommon.sortByStartDate);

  // 下船中イベント結合
  // 下船中様態のイベントをフィルタリング
  const ashoreEvents = targetsEvents.filter(event => {
    return event.event_type === C.SCHEDULING_EVENT_TYPE.ASHORE;
  });
  if (ashoreEvents.length > 1) {
    const currentEvent = ashoreEvents[0];
    await _processConcatAhoreEventAsync(ashoreEvents.slice(1), currentEvent);
  }

  // 乗船中イベント結合
  // 乗船中のイベントをフィルタリング
  const vesselEvents = targetsEvents.filter(event => {
    return event.event_type === C.SCHEDULING_EVENT_TYPE.VESSEL;
  });

  if (vesselEvents.length > 1) {
    const currentEvent = vesselEvents[0];
    await _processConcatVesselEventAsync(vesselEvents.slice(1), currentEvent);
  }
};

/**
 * 乗船中イベント結合
 * @param {Array<EventModel>} vesselEvents CurrentEventの後続イベント
 * @param {EventModel} currentEvent
 * @returns
 */
const _processConcatVesselEventAsync = async (vesselEvents, currentEvent) => {
  if (vesselEvents.length === 0) {
    return;
  }
  const nextEvent = vesselEvents[0];

  // 乗船期間,役職ポジションが異なる場合は次のイベントを処理
  if (
    currentEvent.enterprise_manning_vessel_crew_id !==
      nextEvent.enterprise_manning_vessel_crew_id ||
    currentEvent.enterprise_manning_vessel_role_position_id !==
      nextEvent.enterprise_manning_vessel_role_position_id
  ) {
    // 乗船中の様態が異なる場合は次のイベントを処理
    await _processConcatVesselEventAsync(vesselEvents.slice(1), nextEvent);
    return;
  }

  // 乗船期間,役職ポジションが同じでイベントが繋がっている場合は結合処理
  if (currentEvent.endDate.getTime() === nextEvent.startDate.getTime()) {
    // 計画中 => 予定へ変更されたイベントの場合は、後続イベントの開始日を現在のイベントの終了日に更新
    if (EventHelperCommon.wasPlanned(currentEvent)) {
      await _concatEventAysc(nextEvent, currentEvent);
      await _processConcatVesselEventAsync(vesselEvents.slice(1), nextEvent);
    } else {
      await _concatEventAysc(currentEvent, nextEvent);
      await _processConcatVesselEventAsync(vesselEvents.slice(1), currentEvent);
    }
    // イベントが繋がっていない場合は次のイベントを処理
  } else {
    await _processConcatVesselEventAsync(vesselEvents.slice(1), nextEvent);
  }
};

/**
 * 下船中様態イベント結合処理
 * @param {Array<EventModel>} ashoreEvents CurrentEventの後続イベント
 * @param {EventModel} currentEvent
 * @returns
 */
const _processConcatAhoreEventAsync = async (ashoreEvents, currentEvent) => {
  if (ashoreEvents.length === 0) {
    return;
  }

  const nextEvent = ashoreEvents[0];
  if (
    currentEvent.endDate.getTime() === nextEvent.startDate.getTime() &&
    EventHelperCrew.isSameAshoreEvent(currentEvent, nextEvent)
  ) {
    // 同じ種類の下船中様態イベントで、終了日と開始日が同じ場合は結合
    await _concatEventAysc(currentEvent, nextEvent);
    await _processConcatAhoreEventAsync(ashoreEvents.slice(1), currentEvent);
  } else {
    // 結合できない場合は次のイベントを処理
    await _processConcatAhoreEventAsync(ashoreEvents.slice(1), nextEvent);
  }
};

/**
 * イベントを結合するヘルパー関数
 * event1の開始日がevent2の開始日よりも後の場合は、event1の開始日をevent2の開始日に更新し、
 * event1の終了日がevent2の終了日よりも前の場合は、event1の終了日をevent2の終了日に更新する。
 * 最後に、event2をソフトデリートする。
 * @param {*} event1
 * @param {*} event2
 */
const _concatEventAysc = async (event1, event2) => {
  if (event1.startDate.getTime() > event2.startDate.getTime()) {
    await event1.setStartDate(event2.startDate, false);
  }

  if (event1.endDate.getTime() < event2.endDate.getTime()) {
    await event1.setEndDate(event2.endDate, false);
  }

  EventHelperCommon.softDelete(event2);
};

export { concateEventsAsync };
